import * as React from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

// Import layout
import Layout from "../layouts/main";

// Import components
import SEO from "../components/seo";
import TopPost from "../components/topPost";

// Import styles
import "./styles/blog.scss";

// Import bootstrap
import { Button, Card, Col, Container, Row } from "react-bootstrap";

const BlogPage = () => {
  const data = useStaticQuery(graphql`
    {
      wpPage(title: { eq: "Blog" }) {
        featuredImage {
          node {
            sourceUrl
          }
        }
        seoFields {
          seo {
            description
            title
          }
        }
      }
      allWpPost(
        sort: { fields: date, order: DESC }
        filter: { tags: { nodes: { elemMatch: { name: { ne: "top" } } } } }
      ) {
        nodes {
          date(formatString: "MMMM Do, YYYY")
          excerpt
          featuredImage {
            node {
              id
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: TRACED_SVG, formats: AUTO)
                }
              }
            }
          }
          id
          slug
          title
        }
      }
    }
  `);

  const { allWpPost, wpPage } = data;
  return (
    <Layout>
      <SEO
        title={wpPage.seoFields.seo.title}
        description={wpPage.seoFields.seo.description}
        image={wpPage.featuredImage.node.sourceUrl}
      />
      <div className="blog">
        <TopPost />
        <Row className="all-posts">
          <Container>
            {allWpPost.nodes.map(
              ({ date, id, title, excerpt, featuredImage, slug }) => (
                <Col className="post" xs={12} key={id}>
                  <Card>
                    <GatsbyImage
                      className="image"
                      image={
                        featuredImage.node.localFile.childImageSharp
                          .gatsbyImageData
                      }
                      alt="test"
                    />
                    <Card.Body>
                      <div className="text">
                        <span>{date}</span>
                        <h3 className="shout">{title}</h3>
                        <Link to={slug}>
                          <Button variant="accent">Read More</Button>
                        </Link>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              )
            )}
          </Container>
        </Row>
      </div>
    </Layout>
  );
};

export default BlogPage;
